<template>
  <div class="main-dis-textarea">
    <div class="wrapper-dis-textarea">
      <div class="top">
        <EditTextarea placeholder="吐个槽..." ref="textarea" :limit="200"></EditTextarea>
      </div>
      <div class="bottom">
        <FaceBtn @click="face" ref="face" title="添加表情"></FaceBtn>
        <div>
          <el-checkbox v-model="isPrivate" style="margin-right: 5px" :disabled="submitFlag">私密留言</el-checkbox>
          <el-button type="primary" size="mini" @click="submit" :loading="submitFlag">发表</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import bus from "../../js/bus/faceBus";
    import EditTextarea from '../baseComponent/EditTextarea.vue'
    import FaceBtn from "../iconBtn/FaceBtn";
    import setting from "../../config/setting";
    import {uuid} from "../../js/utils/uuid";

    export default {
        props: ["id"],
        components: {EditTextarea, FaceBtn},
        name: "DisTextarea",
        data() {
            return {
                componentId: uuid(),
                isPrivate: false,
                submitFlag: false,
            }
        },
        mounted() {
            bus.onCallback(this.componentId, (faceItem) => {
                this.$refs.textarea.addFace(faceItem);
            })
        },
        methods: {
            face() {
                bus.show(this.componentId, this.$refs.face.$el.getBoundingClientRect());
            },
            submit() {
                let textarea = this.$refs.textarea;
                let content = textarea.getContent();
                if (!content) {
                    return this.$im.showMessage("请输入留言内容", {icon: 5})
                }
                this.submitFlag = true;
                let params = {
                    content: content,
                    isPrivate: this.isPrivate ? "Y" : "N",
                    userId: this.id
                }
                this.$im.post("/SPACE/v1/dis", params, true,
                    (disId) => {
                        textarea.clean();
                        this.$im.getInfo(({name, avatar, id}) => {
                            //本地回显没有id，所以用uuid代替
                            this.$emit("addCallback", {id: disId, user: {name: name, avatar: avatar, id: id}, content: content, date: "1秒前", isPrivate: params.isPrivate});
                        });
                    }, () => {
                        this.submitFlag = false;
                    }, (msg) => {
                        this.$im.showMessage(msg, {icon: 5})
                    });
            }
        }
    }
</script>
<style scoped>
  @import '../../css/space_common.css';

  .wrapper-dis-textarea {
    display: flex;
    flex-direction: column;
  }

  .top {
    margin-bottom: 6px;
    border: 1px #c7e5eb solid;
    border-radius: 2px;
  }

  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

</style>



// WEBPACK FOOTER //
// src/view/baseComponent/DisTextarea.vue